import { NAME } from './constants';

export const UPDATE_FORM_VALUE = `${NAME}/UPDATE_FORM_VALUE`;